import { render } from "./LogsSysytemTable.vue?vue&type=template&id=4718a230&scoped=true&ts=true"
import script from "./LogsSysytemTable.vue?vue&type=script&lang=ts"
export * from "./LogsSysytemTable.vue?vue&type=script&lang=ts"

import "./LogsSysytemTable.vue?vue&type=style&index=0&id=4718a230&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4718a230"]])

export default __exports__